import type { EnvironmentName } from './environment-name';

export const environment = {
  name: 'development' satisfies EnvironmentName,
  coreOrigin: 'https://core.dev.basilon.ai',
  cloudflareSiteKey: '0x4AAAAAAEfPWrrGvTFhSeBp',
  auth0: {
    domain: 'innovistadev.eu.auth0.com',
    clientId: 'ZDzbIW2IiPaJuRAm6VweJLek9XIe2OIr',
    audience: 'https://api.dev.innovista.com/v1/',
    connection: 'Username-Password-Authentication',
  },
};
